import {
  PARTNERS_LOADING,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_FAILED,
  GET_PARTNER_BY_ID_SUCCESS,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILED,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAILED,
  DELETE_PARTNER_SUCCESS,
  GET_PARTNER_DROPDOWN_SUCCESS,
} from '../actions/PartnersActions';

const initialState = {
  loading: false,
  list: [],
  pagination: {},
  current: null,
  dropdown: [],
  error: null,
};

export default function PartnersReducer(state = initialState, action) {
  switch (action.type) {
    case PARTNERS_LOADING:
      return { ...state, loading: action.payload };
    case GET_PARTNERS_SUCCESS:
      return {
        ...state,
        list: action.payload.data || [],
        pagination: action.payload.pagination || {},
      };
    case GET_PARTNERS_FAILED:
      return { ...state, error: action.payload };
    case GET_PARTNER_BY_ID_SUCCESS:
      return { ...state, current: action.payload };
    case CREATE_PARTNER_SUCCESS:
      return { ...state, list: [action.payload, ...state.list] };
    case CREATE_PARTNER_FAILED:
      return { ...state, error: action.payload };
    case UPDATE_PARTNER_SUCCESS:
      return {
        ...state,
        list: state.list.map((p) => (p.id === action.payload.id ? action.payload : p)),
        current: state.current && state.current.id === action.payload.id ? action.payload : state.current,
      };
    case UPDATE_PARTNER_FAILED:
      return { ...state, error: action.payload };
    case DELETE_PARTNER_SUCCESS:
      return { ...state, list: state.list.filter((p) => p.id !== action.payload.id) };
    case GET_PARTNER_DROPDOWN_SUCCESS:
      return { ...state, dropdown: action.payload || [] };
    default:
      return state;
  }
}
